import { Spinner, Typography } from '@material-tailwind/react'
import { Skeleton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'

const SkeletonCons = () => {

    const { t } = useTranslation()

    const service_id = useSelector((state: RootState) => state.contract.service_id)

    const spinnerColor = service_id === 1 ? 'orange' : service_id === 2 ? 'blue' : 'gray'
    const serviceBorder = service_id === 1 ? 'border-orange-500 border-[3px]' : service_id === 2 ? 'border-blue-600 border-[3px]' : 'border-gray-100 border-2'
    const serviceTitleText = service_id === 1 ? 'text-orange-500' : service_id === 2 ? 'text-blue-600' : 'text-gray-100'

    return (

        <div className={`bg-white ${serviceBorder} p-[24px] tab:p-[32px] lap:p-[48px] rounded-[16px] lap:rounded-[24px] mb-[24px] animate-appear`}>
            <div className='grid grid-cols-2 tab:grid-cols-[38%_62%] items-center tab:items-start'>
                <div>
                    {/* <Typography variant='lead' className='text-gray-700 font-[400] mb-[8px] text-[14px] lap:text-[16px] '>
                        {t('consumption.tko_text_title')}
                    </Typography> */}
                    <Typography variant='lead' className={`${serviceTitleText} font-bold text-[20px] tab:text-[24px] lap:text-[32px]`}>
                        {t('consumption.all_tko_text_title')}
                    </Typography>
                </div>
                <div className=' tab:hidden my-[12px] ml-auto'>
                    <Spinner color={spinnerColor} />
                </div>
                <div className='hidden tab:block'>
                    <div className='flex flex-col gap-[32px]'>
                        <div className='grid grid-cols-4 gap-[16px] tab:gap-[32px] text-gray-600'>
                            <div>{t('consumption.period')}</div>
                            {
                                service_id === 1 &&
                                <>
                                    <div>{t('consumption.declared')}</div>
                                    <div>{t('consumption.detailing')}</div>
                                    <div>{t('consumption.fact')}</div>
                                </>
                            }
                            {
                                service_id === 2 &&
                                <>
                                    <div>{t('consumption.declared_gas')}</div>
                                    <div>{t('consumption.declared_power')}</div>
                                    <div>{t('consumption.fact_gas')}</div>
                                </>
                            }
                        </div>
                        {
                            Array.from(Array(3).keys()).map(key => (
                                <div key={key} className='grid grid-cols-4 gap-[16px] tab:gap-[32px] text-gray-600'>
                                    <Skeleton className='max-w-[120px]' />
                                    <Skeleton className='max-w-[120px]' />
                                    <Skeleton className='max-w-[120px]' />
                                    <Skeleton className='max-w-[120px]' />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkeletonCons
